<template>
    <div>
        <div class="table-layout">
            <el-table :data="auditRecList" border style="width: 100%">
                <el-table-column prop="auditorName" label="审核人" width="200"></el-table-column>
                <el-table-column prop="auditState" label="审核状态" width="100">
                    <template slot-scope="rows">
                        <el-tag type="success" style="background-color: transparent; border: none" v-if="rows.row.auditState === 1" close-transition>
                            <span>审核通过</span>
                        </el-tag>
                        <el-tag type="danger" style="background-color: transparent; border: none" v-if="rows.row.auditState === -1" close-transition>
                            <span>审核未通过</span>
                        </el-tag>
                        <el-tag type="danger" style="background-color: transparent; border: none" v-if="rows.row.auditState === 0" close-transition>
                            <span>未审核</span></el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="auditDesc" label="审核备注" width=""></el-table-column>
                <el-table-column prop="auditTime" label="审核时间" width="180"></el-table-column>
            </el-table>
        </div>

    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import tendBidApi from '../../api/tendBid'

    export default {
        name: 'swb-bid-enroll-audit-rec-list',
        desc: '报名审核记录',
        props: ['id', 'type'],
        data: function () {
            return {
                auditRecList: []
            }
        },
        created: function () {
            this.getAuditRecList();
        },
        methods: {

            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(0);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getAuditRecList();
            },

            getAuditRecList: function () {
                let self = this;
                let filter = {};
                filter.id = this.id;
                let type = this.type;
                let theLoad = MsgBox.loading();
                if(type == 'enroll') {
                    tendBidApi.getBidEnrollAuditRecList(filter, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            self.auditRecList = result.data;
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                } else if(type == 'bid') {
                    tendBidApi.getBidAuditRecListByDocId(filter, function (result) {
			theLoad.hide();
                        if(result.type === "info") {
                            self.auditRecList = result.data;
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/callbid/BidEnrollAuditRecList.vue